<template>
  <v-container fluid>
    <v-card class="pa-3 pt-0" flat>
      <v-layout wrap align-center py-1>
        <v-spacer></v-spacer>
        <list-visible-columns-and-filter
          :visible-columns="visibleColumns"
          :selectable-headers="selectableHeaders"
          v-model="search"
          @change="onVisibleColumnsChange"
        ></list-visible-columns-and-filter>
        <v-dialog
          v-model="serviceEditorDialog"
          max-width="700px"
          :disabled="isNewSupplier"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              color="primary"
              class="mb-2"
              :disabled="
                isNewSupplier ||
                $store.getters.hasAccessTo('suppliers:view_only')
              "
            >
              <v-icon left>mdi-plus-circle</v-icon>Add Service
            </v-btn>
          </template>
          <service-list-item-form
            :service="selectedService"
            :supplier-type="supplierType"
            @onCancel="onServiceEditorCancel($event)"
            @onCloseAndSave="onCloseAndSave($event)"
            @onSave="onServiceSave($event)"
          ></service-list-item-form>
        </v-dialog>
      </v-layout>
      <v-row>
        <list-filters
          :filters="filtersList"
          label="Find Service"
          ref-name="supplierServicesListFilters"
          @searchParamsChanged="searchParamsChanged"
        ></list-filters>
      </v-row>
      <v-dialog v-model="servicePricesEditorDialog" persistent>
        <service-price-list
          v-if="this.selectedService.id"
          :service="selectedService"
          @onCancel="onServicePricesEditorCancel($event)"
        ></service-price-list>
      </v-dialog>
      <v-dialog
        v-model="serviceContentsDialog"
        persistent
        scrollable
        max-width="1200px"
      >
        <v-card>
          <v-card-title class="grey lighten-3">
            <v-row>
              <v-icon class="draggable">mdi-drag</v-icon>
              <v-col class="py-0"
                >{{ this.selectedContentsService.name }} - Contents</v-col
              >
            </v-row>
          </v-card-title>

          <v-card-text>
            <contents
              v-if="this.selectedContentsService.id != null"
              :owner-id="this.selectedContentsService.id"
              owner-name="SERVICE"
            ></contents>
          </v-card-text>

          <v-card-actions class="grey lighten-4">
            <v-spacer></v-spacer>
            <v-btn color="warning" text @click="serviceContentsDialog = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card outlined>
        <v-data-table
          :headers="filteredHeaders"
          :items="filtered"
          :search="search"
          item-key="node.id"
          v-bind="pagingOptions"
          :items-per-page="-1"
          fixed-header
          :height="gridHeight"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td v-if="showColumn('name')">{{ item.node.name }}</td>
                <td v-if="showColumn('altName')">{{ item.node.altName }}</td>
                <td v-if="showColumn('typeName')">{{ item.node.typeName }}</td>
                <td v-if="showColumn('code')">{{ item.node.code }}</td>

                <td v-if="showColumn('minOccupancy')">
                  {{ item.node.minOccupancy }}
                </td>
                <td v-if="showColumn('stdOccupancy')">
                  {{ item.node.stdOccupancy }}
                </td>
                <td v-if="showColumn('maxOccupancy')">
                  {{ item.node.maxOccupancy }}
                </td>
                <td v-if="showColumn('notInUse')">
                  <v-checkbox
                    v-model="item.node.notInUse"
                    primary
                    hide-details
                    :disabled="true"
                    class="ma-0"
                  ></v-checkbox>
                </td>
                <td v-if="showColumn('noReport')">
                  <v-checkbox
                    v-model="item.node.noReport"
                    primary
                    hide-details
                    :disabled="true"
                    class="ma-0"
                  ></v-checkbox>
                </td>
                <td v-if="showColumn('noVoucher')">
                  <v-checkbox
                    v-model="item.node.noVoucher"
                    primary
                    hide-details
                    :disabled="true"
                    class="ma-0"
                  ></v-checkbox>
                </td>
                <td v-if="showColumn('skipMarkup')">
                  <v-checkbox
                    v-model="item.node.skipMarkup"
                    primary
                    hide-details
                    :disabled="true"
                    class="ma-0"
                  ></v-checkbox>
                </td>
                <td v-if="showColumn('skipCircuitDiscount')">
                  <v-checkbox
                    v-model="item.node.skipCircuitDiscount"
                    primary
                    hide-details
                    :disabled="true"
                    class="ma-0"
                  ></v-checkbox>
                </td>
                <td v-if="showColumn('skipAgentCommission')">
                  <v-checkbox
                    v-model="item.node.skipAgentCommission"
                    primary
                    hide-details
                    :disabled="true"
                    class="ma-0"
                  ></v-checkbox>
                </td>
                <td v-if="showColumn('marketPlace')">
                  <v-checkbox
                    v-model="item.node.marketPlace"
                    primary
                    hide-details
                    :disabled="true"
                    class="ma-0"
                  ></v-checkbox>
                </td>
                <td v-if="showColumn('taxCode')">{{ item.node.taxCode }}</td>
                <td>
                  <v-layout row fill-height align-center justify-center>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          small
                          icon
                          v-on="on"
                          class="mx-0"
                          @click="editService(item)"
                          :disabled="
                            $store.getters.hasAccessTo('suppliers:view_only')
                          "
                        >
                          <v-icon color="teal" small>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit Service</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:actiavator="{ on }">
                        <v-btn
                          small
                          icon
                          class="mx-0"
                          @click="editServicePrices(item)"
                          :disabled="
                            $store.getters.hasAccessTo('suppliers:view_only')
                          "
                        >
                          <v-icon color="primary" v-on="on" small
                            >mdi-currency-dollar</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>Service Rates</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          small
                          icon
                          class="mx-0"
                          @click="editServiceContents(item)"
                          :disabled="
                            $store.getters.hasAccessTo('suppliers:view_only')
                          "
                        >
                          <v-icon color="blue" v-on="on" small
                            >mdi-image</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>Service Contents</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          icon
                          small
                          class="mx-0"
                          @click="cloneItem(item)"
                          :disabled="
                            $store.getters.hasAccessTo('suppliers:view_only')
                          "
                        >
                          <v-icon color="primary" small
                            >mdi-content-copy</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>Copy</span>
                    </v-tooltip>
                    <v-btn
                      icon
                      small
                      @click="onEditRemarks(item)"
                      v-if="supplierType != 'ACCOMMODATION'"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" small v-on="on"
                            >mdi-note-outline</v-icon
                          >
                        </template>
                        <span>Remarks</span>
                      </v-tooltip>
                    </v-btn>
                    <confirmation-dialog
                      @onConfirm="onRemove"
                      :item="item"
                      v-if="$store.getters.hasAccessTo('suppliers:delete')"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            small
                            icon
                            class="mx-0"
                            :disabled="
                              $store.getters.hasAccessTo('suppliers:view_only')
                            "
                          >
                            <v-icon color="pink" v-on="on" small
                              >mdi-delete</v-icon
                            >
                          </v-btn>
                        </template>
                        <span>Remove Service</span>
                      </v-tooltip>

                      <p slot="message">
                        This will remove service and all its prices.
                      </p>
                    </confirmation-dialog>
                  </v-layout>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <div v-if="debug">
          <pre>{{ supplierType }}</pre>
        </div>
      </v-card>
    </v-card>
    <clone-service
      :show="showCloneService"
      v-model="selectedService"
      @close="showCloneService = false"
      @complete="onCloneComplete"
    ></clone-service>
    <service-remarks-dialog
      :show="showRemarkDialog"
      @close="showRemarkDialog = false"
      v-model="selectedService"
      @save="onSaveRemarks"
    ></service-remarks-dialog>
  </v-container>
</template>

<script>
import ServiceListItemForm from "./ServiceListItemForm";
import ServicePriceList from "./prices/ServicePriceList";
import ConfirmationDialog from "../../shared/ConfirmationDialog";
import ListVisibleColumnsAndFilter from "../../shared/ListVisibleColumnsAndFilter";
import ListFilters from "../../shared/list-filters/ListFilters";
import serviceFilters from "./service-filters";
import Contents from "../../shared/contents/Contents";
import CloneService from "./CloneService";
import {
  SERVICE_UPDATE_MUTATION,
  SERVICE_CREATE_MUTATION,
  SERVICE_DELETE_MUTATION,
} from "../../../../constants/graphql";
import { pagingOptions } from "../../../../helpers/index";
import ServiceRemarksDialog from "./ServiceRemarksDialog.vue";
import gql from "graphql-tag";
const UPDATE_SERVICE_REMARKS_MUTATION = gql`
  mutation updateServiceRemarks(
    $id: ID!
    $pickupPoint: String
    $dropoffPoint: String
    $pickupTime: String
    $dropoffTime: String
    $address: String
    $coordinates: String
  ) {
    updateService(
      id: $id
      serviceInput: {
        pickupPoint: $pickupPoint
        dropoffPoint: $dropoffPoint
        pickupTime: $pickupTime
        dropoffTime: $dropoffTime
        address: $address
        coordinates: $coordinates
      }
    ) {
      id
    }
  }
`;
export default {
  name: "ServiceList",

  components: {
    ServiceListItemForm,
    ServicePriceList,
    ConfirmationDialog,
    Contents,
    ListVisibleColumnsAndFilter,
    ListFilters,
    CloneService,
    ServiceRemarksDialog,
  },

  props: {
    services: {
      type: Array,
    },
    supplierId: {
      type: String,
    },
    supplierType: {
      type: String,
    },
    showTitle: {
      type: Boolean,
      default: () => true,
    },
  },

  data() {
    return {
      pagingOptions,
      debug: false,
      items: this.services.length ? [...this.services] : [],
      serviceEditorDialog: false,
      servicePricesEditorDialog: false,
      serviceContentsDialog: false,
      search: "",
      filter: { not_in_use_eq: false },
      showCloneService: false,
      visibleColumns: this.$store.getters.localSettings(this.$options.name, [
        "name",
        "typeName",
        "code",
        "noReport",
        "actions",
      ]),
      // order  of columns according to http://tracker.globetrack.ie/issues/4183

      defaultService: {
        name: "",
        altName: "",
        code: "",
        typeName: "",
        minOccupancy: "0",
        stdOccupancy: "0",
        maxOccupancy: "0",
        prices: [],
        notInUse: false,
        skipMarkup: false,
        skipCircuitDiscount: false,
        id: null,
      },
      selectedService: {
        name: "",
        altName: "",
        code: "",
        typeName: "",
        minOccupancy: "0",
        stdOccupancy: "0",
        maxOccupancy: "0",
        notInUse: false,
        skipMarkup: false,
        skipCircuitDiscount: false,
        prices: [],
        id: null,
      },
      selectedContentsService: {},
      editedIndex: -1,
      windowHeight: window.innerHeight,
      fixedHeader: true,
      showRemarkDialog: false,
    };
  },

  computed: {
    headers() {
      return [
        {
          text: "Name",
          value: "node.name",
          name: "name",
        },
        {
          text: "Alternative Name",
          value: "node.altName",
          name: "altName",
        },
        {
          text: "Type",
          value: "node.typeName",
          name: "typeName",
        },
        {
          text: "Code",
          value: "node.code",
          name: "code",
        },
        {
          text: "Min Occupancy",
          value: "node.minOccupancy",
          name: "minOccupancy",
        },
        {
          text: "Std Occupancy",
          value: "node.stdOccupancy",
          name: "stdOccupancy",
        },

        {
          text: "Max Occupancy",
          value: "node.maxOccupancy",
          name: "maxOccupancy",
        },
        {
          text: "Not in use",
          value: "node.notInUse",
          name: "notInUse",
        },
        {
          text: "No Report",
          value: "node.noReport",
          name: "noReport",
        },
        {
          text: "No Voucher",
          value: "node.noVoucher",
          name: "noVoucher",
        },
        {
          text: "Skip Markup",
          value: "node.skipMarkup",
          name: "skipMarkup",
        },
        {
          text: "Skip Circuit Discount",
          value: "node.skipCircuitDiscount",
          name: "skipCircuitDiscount",
        },
        {
          text: "Skip Agent Commission",
          value: "node.skipAgentCommission",
          name: "skipAgentCommission",
        },
        {
          text: "Market Place",
          value: "node.marketPlace",
          name: "marketPlace",
        },
        {
          text: "Tax Code",
          value: "node.taxCode",
          name: "taxCode",
        },
        {
          text: "Actions",
          value: "",
          name: "actions",
          align: "center",
          sortable: false,
        },
      ].filter((h) => {
        if (h.name == "marketPlace") {
          return this.$store.getters.hasAccessTo("third_party:marketplace");
        } else {
          return true;
        }
      });
    },
    gridHeight() {
      if (!this.fixedHeader) {
        return null;
      }
      return this.items && this.items.length >= 10
        ? this.windowHeight - 470
        : null;
    },
    filtered() {
      return this.items.filter((item) => {
        return (
          (this.filter.name_contains != undefined
            ? item.node.name
                .toLowerCase()
                .indexOf(this.filter.name_contains.toLowerCase()) != -1
            : true) &&
          (this.filter.code_contains != undefined
            ? item.node.code
                .toLowerCase()
                .indexOf(this.filter.code_contains.toLowerCase()) != -1
            : true) &&
          (this.filter.not_in_use_eq != undefined
            ? item.node.notInUse == this.filter.not_in_use_eq
            : true)
        );
      });
    },
    filtersList() {
      return serviceFilters.map((f) => {
        f.props.outlined = this.$store.getters.localSettings("outlinedInputs");
        return f;
      });
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    totalCount() {
      return this.services ? this.services.length : 0;
    },
    filteredHeaders() {
      return this.headers.filter(
        (h) => this.visibleColumns.indexOf(h.name) > -1
      );
    },
    isNewSupplier() {
      return this.supplierId == undefined;
    },
    selectableHeaders() {
      return this.headers.filter((h) => h.name != "actions");
    },
  },

  watch: {
    serviceEditorDialog(val) {
      val || this.clearSelectedService();
    },
    services(val) {
      if (val) {
        this.items = [...val];
      }
    },
  },

  methods: {
    onSaveRemarks(payload) {
      this.$apollo
        .mutate({
          mutation: UPDATE_SERVICE_REMARKS_MUTATION,
          variables: { ...payload, id: this.selectedService.id },
        })
        .then((data) => {
          this.showRemarkDialog = false;
          this.$emit("onChange", "Service Saved");
        });
    },
    onEditRemarks(item) {
      this.selectedService = { ...item.node };
      this.showRemarkDialog = true;
    },
    cloneItem(item) {
      this.selectedService = { ...item.node };
      this.showCloneService = true;
    },
    onCloneComplete(payload) {
      this.$store.dispatch("showAppSnackbar", {
        msg: `${payload.name} Created.`,
      });
      this.$emit("onChange", "Service Saved");
      this.showCloneService = false;
    },
    searchParamsChanged(event) {
      this.filter = { ...event };
    },

    onVisibleColumnsChange(event) {
      this.visibleColumns = [...event];
      this.$store.dispatch("updateLocalSettings", {
        [this.$options.name]: event,
      });
    },
    showColumn(fieldName) {
      return this.visibleColumns.find((name) => name == fieldName);
    },
    editService(service) {
      this.editedIndex = this.items.indexOf(service);
      this.selectedService = { ...service.node };
      this.serviceEditorDialog = true;
    },
    onServiceEditorCancel(data) {
      this.serviceEditorDialog = false;
    },
    onServicePricesEditorCancel(data) {
      this.servicePricesEditorDialog = false;
    },
    onCloseAndSave(data) {
      this.onServiceSave(data);
      this.serviceEditorDialog = false;
    },
    onServiceSave(data) {
      if (this.editedIndex > -1) {
        this.updateService(data);
      } else {
        this.createNewService(data);
      }
      this.clearSelectedService();
    },
    clearSelectedService() {
      setTimeout(() => {
        this.selectedService = Object.assign({}, this.defaultService);
        this.editedIndex = -1;
      }, 300);
    },
    updateService(editorData) {
      this.$apollo
        .mutate({
          mutation: SERVICE_UPDATE_MUTATION,
          variables: this.selectedService,
        })
        .then((data) => {
          Object.assign(this.items[this.editedIndex], { node: editorData });
          this.$emit("onChange", "Service Saved");
        });
    },
    createNewService(editorData) {
      //console.log(this.supplierId);
      this.$apollo
        .mutate({
          mutation: SERVICE_CREATE_MUTATION,
          variables: { ...this.selectedService, supplierId: this.supplierId },
        })
        .then((data) => {
          this.items.push({ node: { ...data.data.createService } });
          this.$emit("onChange", "Service Created");
        });
    },
    editServicePrices(service) {
      this.selectedService = { ...service.node };
      this.servicePricesEditorDialog = true;
    },
    editServiceContents(service) {
      //console.log("editServiceContents",service.node)
      this.selectedContentsService = service.node;
      this.serviceContentsDialog = true;
    },
    onRemove(data) {
      //remove service mutation
      this.$apollo
        .mutate({
          mutation: SERVICE_DELETE_MUTATION,
          variables: { serviceId: data.node.id },
        })
        .then((result) => {
          var index = this.items.indexOf(data);
          if (index != -1) {
            this.items.splice(index, 1);
            this.$emit("onChange", "Service Removed");
          }
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowHeight = window.innerHeight;
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/suppliers/services/ServiceList.vue